module.exports = "/img/twitter_icon.svg?22240c892e07496037cbf2cd751469a3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/twitter_icon.svg
// module id = ogAf
// module chunks = 76